<template>
  <div>
    <div class="page-title">Edit Venue Event</div>
    <Form
      v-if="form"
      v-model="form"
      :submit="update"
      btnText="Update Venue Event"
    />
    <Spinner v-else />
  </div>
</template>

<script>
import Form from "./_form.venue-events.page";

export default {
  components: { Form },
  metaInfo() {
    const subject = this.form?.title;
    return {
      title: subject ? `Edit “${subject}” Venue Event` : `Edit Venue Event`,
    };
  },
  data() {
    return {
      form: null,
    };
  },
  created() {
    this.setForm();
  },
  methods: {
    async update() {
      await this.$api.VenueEvent.update(this.form);

      this.$router.push("/venue-events");
    },
    async setForm() {
      const { data } = await this.$api.VenueEvent.get({
        id: this.$route.params.id,
      });
      this.form = data;
    },
  },
};
</script>

<style></style>
